module.exports = __webpack_public_path__ + "img/frame (121).b600373e.jpg";